// extracted by mini-css-extract-plugin
export default {"catalogCard":"catalog_card_catalogCard__IWUy+","catalogCardDesc":"catalog_card_catalogCardDesc__PC7Se"};